import { Checkbox, Drawer, GetProp } from 'antd';
import './style.scss';
import React, { useEffect, useRef, useState } from 'react';
import { DragDropContext, Draggable, Droppable } from '@hello-pangea/dnd';
import { HolderOutlined } from '@ant-design/icons';

interface DrawerProps {
  isOpen: boolean;
  defaultColumnsShow?: any;
  columns?: any;
  localStorageValue: string;
  onClose?: (value: any, isChange: boolean, reorderedColumns: any[]) => void; // Đã cập nhật để bao gồm reorderedColumns
  closeDrawer: () => void;
}

const DrawerAddvance: React.FC<DrawerProps> = ({
  isOpen,
  defaultColumnsShow,
  columns,
  localStorageValue,
  closeDrawer,
  onClose,
}) => {
  const popupRef = useRef<HTMLDivElement>(null);
  const [listColums, setListColums] = useState<any[]>([...columns]);
  const [listChoseColums, setListChoseColums] = useState<any[]>(
    localStorage.getItem(localStorageValue)
      ? JSON.parse(localStorage.getItem(localStorageValue) as string)
      : [...defaultColumnsShow]
  );

  const handleOnClose = () => {
    if (onClose) {
      onClose(listChoseColums, true, listColums); // Truyền các cột được sắp xếp lại
    }
  };

  useEffect(() => {
    const handleOutsideClick = (e: MouseEvent) => {
      if (popupRef.current && !popupRef.current.contains(e.target as Node)) {
        if (onClose) {
          onClose(listChoseColums, false, listColums); // Truyền các cột được sắp xếp lại
        }
      }
    };

    document.addEventListener('mousedown', handleOutsideClick);
    return () => {
      document.removeEventListener('mousedown', handleOutsideClick);
    };
  }, [onClose, listChoseColums, listColums]);

  const handleOnDragEnd = (result: any) => {
    if (!result.destination) return;

    const items = Array.from(listColums);
    const [reorderedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);
    setListColums(items);

    // Cập nhật listChoseColums dựa trên thứ tự mới
    const newChoseColumns = items
      .filter((item) => listChoseColums.includes(item.colId))
      .map((item) => item.colId);
    setListChoseColums(newChoseColumns);
  };

  const onChange: GetProp<typeof Checkbox.Group, 'onChange'> = (checkedValues: any) => {
    setListChoseColums(checkedValues);
  };

  return (
    <Drawer
      placement="right"
      rootClassName="custom-drawer"
      closable={false}
      onClose={closeDrawer}
      open={isOpen}
    >
      <div ref={popupRef} className="filter-setting">
        <div className="title-add-filter">
          <span>Nâng cao</span>
        </div>
        <div className="content-filter-setting t-scrollbar">
          <div className="title-content">Tùy chỉnh trường hiển thị trên bảng</div>
          <div className="list-add-filter-content">
            <DragDropContext onDragEnd={handleOnDragEnd}>
              <Droppable droppableId="columns">
                {(provided) => (
                  <ul
                    {...provided.droppableProps}
                    ref={provided.innerRef}
                    className="drag-drop-content customer-head-list-setting"
                  >
                    <Checkbox.Group onChange={onChange} value={listChoseColums}>
                      {listColums.map((item: any, index: number) => (
                        <Draggable key={item.colId} draggableId={item.colId} index={index}>
                          {(provided) => (
                            <li
                              ref={provided.innerRef}
                              {...provided.draggableProps}
                              {...provided.dragHandleProps}
                              className={`one-op ${listChoseColums.includes(item.colId) ? 'active' : ''}`}
                            >
                              <HolderOutlined className="icon" />
                              <Checkbox className="one-add-filter-content" value={item.colId}>
                                <div className="text">{item.headerName}</div>
                              </Checkbox>
                            </li>
                          )}
                        </Draggable>
                      ))}
                      {provided.placeholder}
                    </Checkbox.Group>
                  </ul>
                )}
              </Droppable>
            </DragDropContext>
          </div>
        </div>
        <div className="footer-filter-block">
          <div className="btn-block">
            <div className="btn btn-primary" onClick={handleOnClose}>
              <div className="text">Lưu</div>
            </div>
          </div>
        </div>
      </div>
    </Drawer>
  );
};

export default DrawerAddvance;
